import { z } from "zod";
import { bicRegex, ibanRegex } from "./add-bank-details.schema";

const defaultError = "Veuillez entrer un nom";

export const updateBankDetailsSchema = z.object({
  accountName: z.string().min(1, defaultError),
  ownerName: z.string().min(1, defaultError),
  bankName: z.string().min(1, defaultError),
  iban: z
    .string()
    .min(1, "Veuillez entrer un IBAN")
    .refine((iban) => {
      const clearedIban = iban.replace(/ /g, "").toUpperCase();

      return clearedIban.match(ibanRegex);
    }, "Veuillez entrer un IBAN valide"),
  bic: z
    .string()
    .min(1, "Veuillez entrer un BIC")
    .refine((bic) => {
      const clearedBic = bic.replace(/ /g, "").toUpperCase();

      return clearedBic.match(bicRegex);
    }, "Veuillez entrer un BIC valide"),
  country: z.string().min(1),
  zipCode: z.string().min(1),
  city: z.string().min(1),
  address: z.string().min(1),
});

export const defaultUpdateBankDetailsValues: UpdateBankDetailsForm = {
  accountName: "",
  ownerName: "",
  bankName: "",
  iban: "",
  bic: "",
  country: "",
  zipCode: "",
  city: "",
  address: "",
};

export type UpdateBankDetailsForm = z.infer<typeof updateBankDetailsSchema>;
